import Minus from './Minus'

export default Minus
// eslint-disable-next-line import/export
export * from './Minus'
